
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><h1>简介</h1>
<h2>起源</h2>
<p>这个项目起名为 <code>howuse</code>，谐音为好用。</p>
<blockquote>
<p>最初开发的时候，准备是一个第三方的关于<code>vue3</code>的<code>composition-api</code>，后来发现<code>vueuse</code>这个项目已经足够优秀，想要的应有尽有。经过一段时间思考，准备做一个关于脚手架项目，但是考察之后关于<code>element-plus</code> 和 <code>ant-design-vue</code>的优秀中后台系统多如牛毛。项目停滞好久之后，准备把项目做成一个vue功能增强项目，什么是增强。增强并不追求造轮子，而是在已有的优秀js或者ui库之上做一些加强功能。</p>
</blockquote>
<h2>开发理念</h2>
<p>项目定义为只做功能增强，不做侵入式开发，尽可能在保证原有api畅通无阻的情况下，使用本插件</p>
<h2>功能进度</h2>
<ol>
<li>axios vue3 响应式增强，支持响应中断、自响应、默认节流</li>
<li>echarts vue3 组件，基础composition-api</li>
<li>pdf 插件，方便将网页元素下载为图片和 pdf</li>
<li>基于ant-design-vue 的crud</li>
<li>基于element-plus 的crud （0%）</li>
<li>额外vue组件，（常用的UI组件，但主流UI框架不具备的组件），动画库依赖：<a href="https://animate.style/">https://animate.style/</a>
<ul>
<li>蒙版</li>
<li>图片预览，命令模式、组件模式</li>
<li>json 数据预览 (该组件依赖的vue-json-pretty插件，由于不提供esm的导出方式，新版的vue也没有了 export default 导出，导致新项目引入失败，集成暂缓)</li>
<li>可拖拽弹窗、且可以操作弹窗底部数据</li>
<li>可拖放组件</li>
<li>无限滚动组件</li>
</ul>
</li>
<li>基于高德地图的常用操作封装（0%）</li>
</ol>
</div>
</template>
